<!--
 * @Autor: haoyi
 * @LastEditors: haoyi
 * @LastEditTime: 2021-11-12 10:19:22
 * @Description:
-->
<template>
  <div class="map-box">
    <div class="title">
      <img
        src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/linenav.png"
        class="m-banner"
        alt="头部图片"
      />
    </div>
    <div class="lineBox">
      <img
        src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-line.png"
        class="m-banner"
        alt="头部图片"
      />
      <a
        v-for="(item, index) in lineArr"
        :key="index"
        :style="{ top: item.top + 'px', right: item.right + 'px' }"
        @click="goDetail(item)"
        @mouseenter="mouseenterLine(item.top, item.right)"
      ></a>
      <div class="finger" ref="finger"></div>
    </div>
  </div>
</template>
<script>
import { lineArr } from '../data/index.js'
export default {
  components: {},
  props: {
    shareFlag: {
      type: Boolean
    }
  },
  data: () => ({
    lineArr: lineArr
  }),
  methods: {
    goDetail (item) {
      this.setAnalytics('解放j6x|主页面|决赛路线', item.val)
      this.$router.push({
        path: '/cityHome',
        query: { id: item.id, cityname: item.val }
      })
    },
    mouseenterLine (top, right) {
      this.$refs.finger.style.top = Number(top) + 10 + 'px'
      this.$refs.finger.style.right = Number(right) - 30 + 'px'
    }
  }
}
</script>
<style lang="less" scoped>
.map-box {
  width: 100%;
  // height: px;
  .lineBox {
    width: 731px;
    margin: 0 auto;
    position: relative;
    cursor: pointer;
    a {
      position: absolute;
      width: 40px;
      height: 40px;
      top: 82px;
      right: 80px;
      z-index: 100;
    }
  }
  .title {
    margin: 70px auto 40px;
    text-align: center;
  }
  .finger {
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/hand.png')
      center center no-repeat;
    width: 51px;
    height: 51px;
    animation: fingerHandle 1s ease infinite both;
    position: absolute;
    top: 104px;
    right: 48px;
  }
}

@keyframes fingerHandle {
  0% {
    transform: none;
  }
  70% {
    transform: scale3d(0.8, 0.8, 0.8);
  }
  100% {
    transform: none;
  }
}
@media screen and (min-width: 752px) {
  .map-box {
  }
}
</style>
